import { Tooltip, useTheme } from '@ethings/ui-toolkit';
import { styled } from '@mui/material';
import { FC, PropsWithChildren, ReactNode } from 'react';

interface MapOverlayProps extends PropsWithChildren {
  'data-testid'?: string;
  backgroundColor?: string;
  tooltip?: ReactNode;
}

export const MapOverlay: FC<MapOverlayProps> = ({ children, tooltip, backgroundColor, ...props }) => {
  const theme = useTheme();
  const overlayBackground = backgroundColor || theme.palette.background.paper;

  const Overlay = styled('div')({
    display: 'inline-flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    backgroundColor: overlayBackground,
    borderRadius: theme.shape.borderRadius * 2,
    gap: `0 ${theme.spacing(2)}`,
    width: 'fit-content',
    boxShadow: theme.shadows[3],
    overflow: 'hidden',
  });

  if (tooltip) {
    return <Tooltip arrow title={tooltip}>
      <Overlay data-testid={props['data-testid']}>
        {children}
      </Overlay>
    </Tooltip>;
  }

  return <Overlay data-testid={props['data-testid']}>
    {children}
  </Overlay>;
};
